export default "__VITE_ASSET__c40543bb__"